import {Inject, Injectable} from "@angular/core";
import {Constants} from '../helpers/constants';
import {DOCUMENT} from "@angular/common";

@Injectable()
export class IndexConfigService {
  public api: string;
  public externalApi: string;

  constructor(@Inject(DOCUMENT)document: Document) {
    this.api = '';//window.location.origin;
    this.externalApi = (<any>window).externalApi;
  }
}
